
const Megamenu = {
  props: [
    'activeChild'
  ],
  methods: {
    activateSection: function(id) {
      bus.$emit('megamenu_toggle', id)
    },
  }
}


export default Megamenu
